import { EobControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

interface UpdateEobParams {
  eobId: string;
  payerId: string;
  eobNumber: string;
  paymentMethod: string;
  totalPaymentAmount: string;
  statementDate: string;
  checkEftNumber?: string;
}

export const useUpdateEob = () =>
  useMutationWithLoading(async (params: UpdateEobParams) =>
    new EobControllerApi(getConfigObject()).updateEob(
      params.eobId,
      params.payerId,
      params.eobNumber,
      params.totalPaymentAmount,
      params.paymentMethod,
      params.checkEftNumber,
      params.statementDate,
      getXtenantId()
    )
  );
